import $ from "jquery";
import Swiper, {
    Autoplay,
    EffectCards,
    EffectCreative,
    EffectCube,
    EffectFade,
    EffectFlip,
    FreeMode,
    Navigation,
    Pagination,
} from "swiper";
import Lottie from "lottie-web";
import WOW from "wowjs";
import lozad from "lozad";
import tippy from "tippy.js";
// import Cookies from "js-cookie";
import counterUp from 'counterup2';
import axios from "axios";
import Swal from "sweetalert2";
window.Swal = Swal;
window.axios = axios;
import "./swiper.animate";
let swiperAnimate = window.swiperAnimate;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

window.$ = window.jQuery = $;
window.lottie = Lottie;
window.counterUp=counterUp;

new WOW.WOW({
    live: false,
}).init();

// 导航栏
document.addEventListener("DOMContentLoaded", function () {
    // open
    const trigger = document.querySelectorAll(".navbar-trigger");
    const menu = document.querySelectorAll(".navbar-menu");

    if (trigger.length && menu.length) {
        for (var i = 0; i < trigger.length; i++) {
            trigger[i].addEventListener("click", function () {
                for (var j = 0; j < menu.length; j++) {
                    menu[j].classList.toggle("hidden");
                }
            });
        }
    }

    // 关闭按钮
    const close = document.querySelectorAll(".navbar-close");
    const backdrop = document.querySelectorAll(".navbar-backdrop");

    if (close.length) {
        for (var i = 0; i < close.length; i++) {
            close[i].addEventListener("click", function () {
                for (var j = 0; j < menu.length; j++) {
                    menu[j].classList.toggle("hidden");
                }
            });
        }
    }

    if (backdrop.length) {
        for (var i = 0; i < backdrop.length; i++) {
            backdrop[i].addEventListener("click", function () {
                for (var j = 0; j < menu.length; j++) {
                    menu[j].classList.toggle("hidden");
                }
            });
        }
    }
});
if (window.matchMedia("(min-width: 640px)").matches) {
    const observer = lozad(".lozad", {
        loaded: function (el) {},
    });
    observer.observe();
}

(function ($) {
    "use strict";
    /*-----------------
        Menu Stick
    -----------------*/
    var header = $(".sticky-bar");
    var win = $(window);
    win.on("scroll", function () {
        var scroll = win.scrollTop();
        if (scroll < 32) {
            header.removeClass("stick");
        } else {
            header.addClass("stick");
        }
    });

    /*---------------------
        Mobile menu active
    ------------------------ */
    var $offCanvasNav = $(".mobile-menu"),
        $offCanvasNavSubMenu = $offCanvasNav.find(".dropdown");

    /*Add Toggle Button With Off Canvas Sub Menu*/
    $offCanvasNavSubMenu.parent().prepend('<span class="menu-expand">+</span>');

    /*Close Off Canvas Sub Menu*/
    $offCanvasNavSubMenu.slideUp();

    /*Category Sub Menu Toggle*/
    $offCanvasNav.on("click", "li a, li .menu-expand", function (e) {
        var $this = $(this);
        if (
            $this
                .parent()
                .attr("class")
                .match(
                    /\b(menu-item-has-children|has-children|has-sub-menu)\b/
                ) &&
            ($this.attr("href") === "#" || $this.hasClass("menu-expand"))
        ) {
            e.preventDefault();
            if ($this.siblings("ul:visible").length) {
                $this.parent("li").removeClass("active");
                $this.siblings("ul").slideUp();
            } else {
                $this.parent("li").addClass("active");
                $this
                    .closest("li")
                    .siblings("li")
                    .removeClass("active")
                    .find("li")
                    .removeClass("active");
                $this.closest("li").siblings("li").find("ul:visible").slideUp();
                $this.siblings("ul").slideDown();
            }
        }
    });


    //首页banner
    const swiper = new Swiper(".header-banner", {
        // configure Swiper to use modules
        modules: [Navigation, Pagination, Autoplay],
        breakpoints: {
            640: {
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            },
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        on: {
            init: function () {
                swiperAnimate(this); //初始化完成开始动画
            },
            slideChange: function () {
                // console.log(this)
                swiperAnimate(this); //每个slide切换结束时也运行当前slide动画
            },
        },
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        loop: true,
        autoplay: {
            delay: 4000,
        },
    });
    // swiper.on('slideChange', function () {
    //     if(swiper.realIndex==1){
    //         $('#logo-light').removeClass('hidden')
    //         $('#logo-dark').addClass('logo-dark')
    //         $('#nav-text').addClass('text-white')
    //         $('#navbar-trigger').addClass('navbar-dark')
    //     }else{
    //         $('#logo-light').addClass('hidden')
    //         $('#logo-dark').removeClass('logo-dark')
    //         $('#nav-text').removeClass('text-white')
    //         $('#navbar-trigger').removeClass('navbar-dark')
    //     }
    //   });

    //为什么选择banner
    const swiper2 = new Swiper(".why-choose", {
        // configure Swiper to use modules
        modules: [Navigation, Pagination, Autoplay, EffectFade],
        navigation: {
            nextEl: ".swiper-button-next-light",
            prevEl: ".swiper-button-prev-light",
        },
        effect: "fade",
        loop: true,
        autoplay: {
            delay: 3000,
        },
    });

    $(".whyus-btn").on("click", function (e) {
        $(".whyus-btn").each(function (i, el) {
            $(el).removeClass("whyus-btn-selected");
        });
        $(this).parent().addClass("whyus-btn-selected");
        const si = $(this).data("swiperindex");
        swiper2.slideToLoop(si);
    });
    swiper2.on("slideChange", function () {
        $(".whyus-btn").each(function (i, el) {
            $(el).parent().removeClass("whyus-btn-selected");
        });
        const id = swiper2.realIndex;
        const wb = 'button[data-swiperindex="' + id + '"]';
        $(wb).parent().addClass("whyus-btn-selected");
    });

    //服务点击切换
    function switchService() {
        $(".services-switch").on("click", function () {
            $(".services-switch").each(function (i, el) {
                $(el).addClass("service-dark");
            });
            $(this).removeClass("service-dark");
            $(this).addClass("service-light");
            const target = "#" + $(this).data("target");
            $(".services-show").each(function (i, el) {
                $(el).addClass("hidden");
                $(el).removeClass("grid");
            });
            $(target).removeClass("hidden");
            $(target).addClass("grid");
        });
    }
    switchService();

    // 服务tab轮播
    // var autoTab = setInterval(changeTab, 5000);
    // var tabIndex = 0;
    // $(".services-switch").on(
    //     "click",
    //     function () {
    //         clearInterval(autoTab);
    //     },
    //     function () {
    //         autoTab = setInterval(changeTab, 5000);
    //     }
    // );
    // function changeTab() {
    //     $(".services-switch").each(function (i, el) {
    //         $(el).addClass("service-dark");
    //     });
    //     $(".services-switch")
    //         .eq(tabIndex)
    //         .removeClass("service-dark")
    //         .addClass("service-light")
    //         .siblings()
    //         .removeClass("service-light")
    //         .addClass("service-dark");
    //     console.log($(".services-switch").eq(tabIndex));
    //     console.log(tabIndex);
    //     if ($("#service-" + tabIndex)) {
    //         $("#service-" + tabIndex)
    //             .removeClass("hidden")
    //             .addClass("grid")
    //             .siblings()
    //             .addClass("hidden")
    //             .removeClass("grid");
    //     }
    //     tabIndex++;
    //     if (tabIndex == 2) {
    //         tabIndex = 0;
    //     }
    // }

    // 客服
    if (window.matchMedia("(min-width: 640px)").matches) {
        $("#kefu").hide();
        $(window).on("scroll resize", function () {
            if ($(window).scrollTop() <= 0) {
                $("#kefu").hide();
            } else {
                $("#kefu").show();
            }
        });
    }
    //图片
    const wpcontent = $("#wp-content").html();
    tippy("#wpqr", {
        content: wpcontent,
        offset: [0, 30],
        allowHTML: true,
        theme: "light",
        placement: "left",
        animation: "shift-toward-extreme",
    });
    //底部图片
    tippy("#footer-weixin", {
        content: wpcontent,
        allowHTML: true,
        theme: "light",
        placement: "top",
        animation: "shift-toward-extreme",
    });
    if (window.matchMedia("(min-width: 1024px)").matches) {
        // if (!Cookies.get("shsus")) {
        //     Cookies.set("shsus", "1", { expires: 7 });
        // }
        // if (Cookies.get("shsus") === "1") {
        $("#close-sus").on("click", function (e) {
            $("#suspending").hide();
            // Cookies.set("shsus", "2", { expires: 7 });
        });
        $(window).on("scroll resize", function () {
            if ($(window).scrollTop() <= 600) {
                $("#suspending").addClass("hidden");
                $("#suspending").removeClass("flex");
            } else {
                $("#suspending").addClass("flex");
                $("#suspending").removeClass("hidden");
            }
        });
        // }
    }

    // 加一个确认按钮
    const swalWithTailButtons = Swal.mixin({
        customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-cancel",
        },
        buttonsStyling: false,
    });

    //底部存留
    function validSus(data, title = "输入验证码") {
        swalWithTailButtons
            .fire({
                title: title,
                html: `<div class="flex mx-auto">
                <img id="captcha-sus" src=""><input type="text" id="captcha-api" class="my-1 mx-4 border border-slate-100 bg-slate-50 rounded-md px-4 placeholder:text-sm"
                placeholder="输入验证码"><input type="hidden" id="captcha-key" class="hidden"><div>`,
                showCancelButton: true,
                confirmButtonText: "提交",
                cancelButtonText: "取消",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    const captcha = $("#captcha-api").val();
                    const key = $("#captcha-key").val();
                    axios
                        .post("api/customer/store/fromsuspending", {
                            captcha: captcha,
                            key: key,
                            phone: data.phone,
                            business: data.business,
                        })
                        .then(function (response) {
                            if (response.data.success) {
                                try {
                                    if (typeof gtag === "function") {
                                        gtag("event", "getleads", {
                                            phone: data.phone,
                                            position: "suspending",
                                        });
                                    } else {
                                        console.log("something wrong");
                                    }
                                } catch (e) {}
                                // Cookies.set("shsus", "2", { expires: 1 });
                                $("#suspending").hide();
                                swalWithTailButtons.fire(
                                    "提交成功",
                                    "感谢您的支持，我们会尽快和您取得联系！",
                                    "success"
                                );
                            } else {
                                validSus(data, "验证码错误，请重新输入");
                                getCaptcha("#captcha-sus", "#captcha-key");
                            }
                        });
                }
            });
    }

    //联系我们
    function validCinfo(data, title = "输入验证码") {
        swalWithTailButtons
            .fire({
                title: title,
                html: `<div class="flex mx-auto">
                <img id="cinfo-img" src=""><input type="text" id="cinfo-api" class="my-1 mx-4 border border-slate-100 bg-slate-50 rounded-md px-4 placeholder:text-sm"
                placeholder="输入验证码"><input type="hidden" id="cinfo-key" class="hidden"><div>`,
                showCancelButton: true,
                confirmButtonText: "提交",
                cancelButtonText: "取消",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    data.captcha = $("#cinfo-api").val();
                    data.key = $("#cinfo-key").val();
                    axios({
                        method: "post",
                        url: "api/customer/store/fromhome",
                        data: data,
                    }).then(function (response) {
                        // console.log(response.data);
                        if (response.data.success) {
                            try {
                                if (typeof gtag === "function") {
                                    gtag("event", "getleads", {
                                        phone: data.phone,
                                        position: "contact",
                                    });
                                } else {
                                    console.log("something wrong");
                                }
                            } catch (e) {}

                            swalWithTailButtons.fire(
                                "提交成功",
                                "感谢您的支持，我们会尽快和您取得联系！",
                                "success"
                            );
                            $("#c-info :input")
                                .not(":button, :submit, :reset, :hidden")
                                .val("");
                            // $("#ci-btn").attr('disabled',true)
                        } else {
                            validCinfo(data, "验证码错误，请重新输入");
                            getCaptcha("#cinfo-img", "#cinfo-key");
                        }
                    });
                }
            });
    }

    //点击图片更换验证码
    function getCaptcha(imgID, keyId) {
        axios.get("/captcha/api/math").then(function (response) {
            $(imgID).attr("src", response.data.img);
            $(keyId).val(response.data.key);
        });
    }

    //底部存留提交流程
    $("#sus-submit").on("click", function (e) {
        const data = {};
        data.phone = $("#sus-phone").val();
        data.business = $("#sus-business").val();
        if (data.phone && data.business) {
            validSus(data);
            getCaptcha("#captcha-sus", "#captcha-key");
            $("#captcha-sus").on("click", function () {
                getCaptcha("#captcha-sus", "#captcha-key");
            });
        } else {
            if (!data.phone) {
                $("#sus-phone").addClass("placeholder:text-red-400");
                $("#sus-phone").attr("placeholder", "手机号码不能为空！");
            }
            if (!data.business) {
                $("#sus-business").addClass("placeholder:text-red-400");
                $("#sus-business").attr("placeholder", "咨询信息不能为空！");
            }
        }
    });

    //联系我们提交流程
    $("#ci-btn").on("click", function () {
        const data = {};
        data.name = $("#name").val();
        data.phone = $("#phone").val();
        data.email = $("#email").val();
        data.wechat = $("#wechat").val();
        data.city = $("#city").val();
        data.company = $("#company").val();
        data.business = $("input[name='business']:checked").val();

        if (data.name && data.phone && data.email && data.company) {
            validCinfo(data);
            getCaptcha("#cinfo-img", "#cinfo-key");
            $("#cinfo-img").on("click", function () {
                getCaptcha("#cinfo-img", "#cinfo-key");
            });
        }
    });

    const swiperAdsType = new Swiper(".adsTypeSwiper", {
        // configure Swiper to use modules
        modules: [Navigation, Pagination, Autoplay, EffectFade],
        direction: "vertical",
        autoHeight: true,
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        on: {
            init: function () {
                swiperAnimate(this); //初始化完成开始动画
            },
            slideChange: function () {
                // console.log(this)
                swiperAnimate(this); //每个slide切换结束时也运行当前slide动画
            },
        },
    });

    $(".btn-adsType").on("click mouseover", function (e) {
        $(".btn-adsType").each(function (i, el) {
            $(el).removeClass("btn-adsType-selected");
        });
        $(this).addClass("btn-adsType-selected");
        const si = $(this).data("spi");
        swiperAdsType.slideToLoop(si);
    });
    // swiperAdsType.on("slideChange", function () {
    //     $(".btn-adsType").each(function (i, el) {
    //         $(el).parent().removeClass("btn-adsType-selected");
    //     });
    //     const id = swiperAdsType.realIndex;
    //     const wb = 'button[data-swiperindex="' + id + '"]';
    //     $(wb).parent().addClass("btn-adsType-selected");
    // });

    const swiperFbsOne = new Swiper(".fbsSwiper-one", {
        // configure Swiper to use modules
        modules: [Navigation, Pagination, Autoplay],
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });

    $(".according").on("click", function () {
        $(".according").each(function (index, el) {
            $(el).removeAttr("open");
        });
    });
    $("body").on("mouseover", ".according", function (event) {
        if (event.type == "mouseover") {
            $(".according").each(function (index, el) {
                $(el).removeAttr("open");
            });
            $(this).prop("open", true);
            swiperFbsOne.slideToLoop($(this).data("ser"));
        } else if (event.type == "mouseout") {
        }
    });
    swiperFbsOne.on("slideChange", function () {
        $(".according").each(function (index, el) {
            $(el).removeAttr("open");
        });
        const id = swiperFbsOne.realIndex;
        const wb = 'details[data-ser="' + id + '"]';
        $(wb).prop("open", true);
    });

    const swiperFbsTwo = new Swiper(".fbsSwiper-two", {
        // configure Swiper to use modules
        modules: [Navigation, Pagination, Autoplay],
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });
    $(".accordingx").on("click", function () {
        $(".accordingx").each(function (index, el) {
            $(el).removeAttr("open");
        });
    });
    $("body").on("mouseover", ".accordingx", function (event) {
        if (event.type == "mouseover") {
            $(".accordingx").each(function (index, el) {
                $(el).removeAttr("open");
            });
            $(this).prop("open", true);
            swiperFbsTwo.slideToLoop($(this).data("serx"));
        } else if (event.type == "mouseout") {
        }
    });
    swiperFbsTwo.on("slideChange", function () {
        $(".accordingx").each(function (index, el) {
            $(el).removeAttr("open");
        });
        const id = swiperFbsTwo.realIndex;
        const wb = 'details[data-serx="' + id + '"]';
        $(wb).prop("open", true);
    });

    const swiperCases = new Swiper(".fb-cases", {
        modules: [Navigation, Pagination, Autoplay, FreeMode],
        slidesPerView: 'auto',
        spaceBetween: 50,
        slidesPerGroup: 1,
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    // Google页面
    const swiperAdsSeries = new Swiper(".adsSeriesSwiper", {
        // configure Swiper to use modules
        modules: [Navigation, Pagination, Autoplay, EffectFade],
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        on: {
            init: function () {
                swiperAnimate(this); //初始化完成开始动画
            },
            slideChange: function () {
                // console.log(this)
                swiperAnimate(this); //每个slide切换结束时也运行当前slide动画
            },
        },
    });

    $(".btn-adsSeries").on("click mouseover", function (e) {
        $(".btn-adsSeries").each(function (i, el) {
            $(el).removeClass("btn-adsSeries-selected");
        });
        $(this).addClass("btn-adsSeries-selected");
        const si = $(this).data("spi");
        swiperAdsSeries.slideToLoop(si);
    });
    $('.anchor-btn').each(function(i,el){
        if(el.href==window.location.href){
            $(el).closest('li').addClass("border-b-4 border-b-primary pb-3");
        }
    })
    $('.anchor-btn').on('click',function(){
        $('.anchor-btn').each(function(i,el){
                $(el).closest('li').removeClass("border-b-4 border-b-primary pb-3");
        })
        $(this).closest('li').addClass("border-b-4 border-b-primary pb-3");
    })
    

// Start counting, do this on DOM ready or with Waypoints.
$( '.counter' ).each(function(i,el){
    counterUp( el,{
        duration: 2000,
        delay: 16,
    } )
});
    
})(jQuery);
